<div class="login-wrapper" *ngIf="isSignedIn()">
    <h3>{{'AlreadyLoggedIn'|translate}}</h3>
    <div class="btn-group">
        <button type="submit" value="submit" class="btn btn-primary" (click)="goToStartPage()">
            {{ 'GoToStartPage' | translate }}
        </button>
        <button type="submit" value="submit" class="btn btn-danger" (click)="signOut()">
            {{ 'SignOut' | translate }}
        </button>
    </div>
</div>
<div class="login-wrapper" *ngIf="!requires2Fa && isSignedOut()">
    <img src="assets/images/ncvib.svg" alt="NCVIB"/>
    <form class="login-form form-inline" #form="ngForm">
        <input type="text"
               class="form-control"
               [(ngModel)]="userName"
               id="inputUsername"
               name="inputUsername"
               autocomplete="userName"
               (ngModelChange)="clearErrorMessage()"
               placeholder="{{ 'Username' | translate }}"/>

        <div class="input-group">
            <input type="{{ hidePassword ? 'password' : 'text' }}"
                   class="form-control"
                   [(ngModel)]="password"
                   id="inputPassword"
                   name="inputPassword"
                   autocomplete="current-password"
                   (ngModelChange)="clearErrorMessage()"
                   placeholder="{{ 'Password' | translate }}">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" (click)="togglePasswordVisibility()">
                    <i class="fa" [ngClass]="{'fa-eye': hidePassword, 'fa-eye-slash': !hidePassword}"></i>
                </button>
            </div>
        </div>
        <select ngbDropdown
                id="inputLanguage"
                [(ngModel)]="selectedLanguage"
                (ngModelChange)="languageChanged()"
                class="form-select"
                name="inputLanguage">
            <option *ngFor="let language of languages" [ngValue]="language">
                {{ language.name }}
            </option>
        </select>
        <label style="color: red;">{{ errorMessage | translate }}</label>
        <div class="form-check remember-me">
            <checkbox name="rememberMe" [(ngModel)]="rememberMe">{{ 'RememberMe' | translate }}</checkbox>
        </div>
        <button type="submit" value="submit" class="btn btn-primary" (click)="login()" [disabled]="this.languages.length == 0">
            {{ 'LogOn' | translate }}
        </button>
    </form>
    <div class="login-footer">
        <a href="https://www.nitroconsult.com/en/login-ncvib" target="_blank">{{ 'AboutNCVIB' | translate }}</a> |
        <a routerLink="/forgot-password">{{ 'ForgotPassword' | translate }}</a> |
        <a href="mailto:support@ncvib.com">{{ 'ContactUs' | translate }}</a>
    </div>
</div>

<div class="two-fa-login" *ngIf="requires2Fa">
    <otp (verificationCodeChange)="onVerificationCodeChanged($event)"></otp>
</div>

